<template>
    <transition name="fade">
        <div class="gallery-slider fixed inset-0 flex flex-col">
            <div class="flex justify-end pr-6 pt-6 sm:pr-10 sm:pt-10 mb-4">
                <button @click="$emit('close')">
                    <img src="/images/icons/close_white.svg">
                </button>
            </div>
            <div class="images-container flex items-center flex-grow sm:mx-5 lg:mx-10 lg:mb-32 lg:space-x-8">
                <div @click="prev" class="x-arrow-link x-arrow-link--desktop x-arrow-link--white x-arrow-link--prev">
                    <button class="arrow-link-btn">
                        <span class="arrow-link-btn-line-holder">
                            <span class="arrow-link-btn-line-top"></span>
                            <span class="arrow-link-btn-line"></span>
                            <span class="arrow-link-btn-line-bottom"></span>
                        </span>
                    </button>
                </div>
                <div class="images flex-grow grid">
                    <div v-for="([image, title], index) in images" :key="image"
                        class="image flex justify-center items-center"
                        :class="[imageShownIndex === index ? 'opacity-1' : 'opacity-0']">
                        <img :src="image" :alt="title">
                    </div>
                </div>
                <div @click="next" class="x-arrow-link x-arrow-link--desktop x-arrow-link--white x-arrow-link--next">
                    <button class="arrow-link-btn">
                        <span class="arrow-link-btn-line-holder">
                            <span class="arrow-link-btn-line-top"></span>
                            <span class="arrow-link-btn-line"></span>
                            <span class="arrow-link-btn-line-bottom"></span>
                        </span>
                    </button>
                </div>
            </div>
            <div class="flex justify-center items-center lg:hidden space-x-8 mt-4 lg:mt-16 mb-8">
                <div @click="prev" class="x-arrow-link x-arrow-link--white x-arrow-link--still x-arrow-link--prev">
                    <button class="arrow-link-btn">
                        <span class="arrow-link-btn-line-holder">
                            <span class="arrow-link-btn-line-top"></span>
                            <span class="arrow-link-btn-line"></span>
                            <span class="arrow-link-btn-line-bottom"></span>
                        </span>
                    </button>
                </div>
                <div @click="next" class="x-arrow-link x-arrow-link--white x-arrow-link--still x-arrow-link--next">
                    <button class="arrow-link-btn">
                        <span class="arrow-link-btn-line-holder">
                            <span class="arrow-link-btn-line-top"></span>
                            <span class="arrow-link-btn-line"></span>
                            <span class="arrow-link-btn-line-bottom"></span>
                        </span>
                    </button>
                </div>
            </div>
        </div>
    </transition>
</template>

<script>
export default {
    props: {
        images: {
            type: Array,
            required: true,
        },
        sliderInitialImageIndex: {
            type: Number,
            required: true,
        }
    },

    data() {
        return {
            imageShownIndex: 0,
        }
    },

    watch: {
        sliderInitialImageIndex(sliderInitialImageIndex) {
            this.imageShownIndex = sliderInitialImageIndex;
        }
    },

    methods: {
        prev() {
            let index = this.imageShownIndex - 1;
            this.imageShownIndex = index < 0 ? this.images.length - 1 : index;
        },
        next() {
            let index = this.imageShownIndex + 1;
            this.imageShownIndex = index === this.images.length ? 0 : index;
        }
    },
}
</script>

<style lang="scss" scoped>
.gallery-slider {
    z-index: 10001;
    background-color: rgba(0, 0, 0, 0.89);

    button {
        outline: none;
    }

    .images-container {
        max-height: calc(100vh - 144px);

        .images {
            max-height: calc(100vh - 144px);
            grid-template-columns: 1fr;

            .image {
                max-height: calc(100vh - 144px);
                grid-area: 1 / 1 / 2 / 2;
                transition: opacity 0.3s ease-in;

                &.opacity-1 {
                    transition: opacity 0.3s ease-out;
                }

                img {
                    max-height: calc(100vh - 144px);
                }
            }
        }
    }

    .x-arrow-link {
        &--desktop {
            display: none !important;

            @media (min-width: 1024px) {
                display: block !important;
            }
        }

        &--prev {
            transform: rotate(180deg);
            margin-bottom: -5px;
        }
    }
}
</style>
